import Card from './Card';
function Tours({tour,removeTour}){
    return(
        <div className="flex flex-col items-center justify-center">
            <div>
                <h2 className="text-5xl m-[6vh] border-dashed border-[7px] border-[#0111A0] rounded-[20px] py-[1vh] px=[5vw]">Tour With Arjun</h2>
            </div>
            <div className="flex item-center justify-center flex-wrap max-w-[1300px] my-[0] mx-auto">
            {
                tour.map( (tour) => {
                    return <Card {...tour} removeTour={removeTour}></Card>;
                })
            }    
            </div>
        </div>
    );
}
export default Tours;